import type { StateType } from '../reducers';

export const phoneLinesEditingDataSelector = (state: StateType): Object[] => state.phoneLinesEditing?.data || [];

export const phoneLinesEditingSelector = (state: StateType): boolean => state.phoneLinesEditing?.editing;
